import MemberTrialPlanVue from '@/views/member/trial-plan/trial-plan.vue';

const basePath = '/member/trial-plan';
const role = 'member'; // 角色身份

export const M_PLAN_INDEX = 'm-plan-index';
export const M_PLAN_SIGN_UP = 'm-plan-sign-up';
export const M_PLAN_INDEX_2024 = 'm-plan-index_2024';
export const M_PLAN_SIGN_UP_2024 = 'm-plan-sign-up_2024';
export const M_PLAN_INDEX_backMember = 'm-plan-index_backMember';
export const M_PLAN_SIGN_UP_backMember = 'm-plan-sign-up_backMember';
export const M_PLAN_ACTIVITY = 'm-plan-activity';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: MemberTrialPlanVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: M_PLAN_INDEX,
      component: () => import(
        /* webpackChunkName: "sign-up" */
        `@/views/${role}/trial-plan/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/sign-up`,
      name: M_PLAN_SIGN_UP,
      component: () => import(
        /* webpackChunkName: "sign-up" */
        `@/views/${role}/trial-plan/sign-up.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/index_2024`,
      name: M_PLAN_INDEX_2024,
      component: () => import(
        /* webpackChunkName: "sign-up" */
        `@/views/${role}/trial-plan/index_2024.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/sign-up_2024`,
      name: M_PLAN_SIGN_UP_2024,
      component: () => import(
        /* webpackChunkName: "sign-up" */
        `@/views/${role}/trial-plan/sign-up_2024.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/index_backMember`,
      name: M_PLAN_INDEX_backMember,
      component: () => import(
        /* webpackChunkName: "sign-up" */
        `@/views/${role}/trial-plan/index_backMember.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/sign-up_backMember`,
      name: M_PLAN_SIGN_UP_backMember,
      component: () => import(
        /* webpackChunkName: "sign-up" */
        `@/views/${role}/trial-plan/sign-up_backMember.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/activity`,
      name: M_PLAN_ACTIVITY,
      component: () => import(
        /* webpackChunkName: "sign-up" */
        `@/views/${role}/trial-plan/activity.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
  ]
};
